module.exports = __webpack_public_path__ + "img/failed_transaction.32d3f440.png";